<template lang="html">
   <div class="nav-side">
      <div class="header clearfix">
         <div class="brand">
            <div class="h5">{{main_lang.brand}}</div>
         </div>
         <div class="navTrigger active" @click="toggleNav()">
            <i></i><i></i><i></i>
         </div>
      </div>
      <div class="menu-content">
         <div v-for="(route,i) in routes" :key="i">
            <div class="heading" v-if="route.type === 'heading'">
               <span class="text">
                  {{route.name}}
               </span>
               <span class="dot"></span>
            </div>
            <div v-if="!route.type">
               <div v-if="route.children">
                  <div 
                     :id="`menu-${route.component}`" 
                     class="menu-item clearfix" 
                     :class="{'active' : getChildren(route.children).includes($route.name)}" 
                     @click="toggleCollapse(route.component)"
                     v-show="!route.has_permission || childrenHavePermissions(route.children)"
                  >
                     <div :class="route.icon || 'fa fa-columns'"></div>
                     <div class="menu-text">{{route.name || route.component}}</div>
                     <div class="fa fa-chevron-down"></div>
                  </div>
                  <div :id="route.component" class="collapse collapse-box">
                     <router-link v-for="(r,j) in route.children" :key="j" :to="{name: r.component}" v-show="!r.has_permission ||  hasPermission(r.resource)">
                        <div class="menu-item clearfix">
                           <div class="fa fa-circle fa-outline"></div>
                           <div class="menu-text" :class="{'active': $route.name === r.component}">{{r.name || r.component}}</div>
                        </div>
                     </router-link>
                  </div>
               </div>
               <router-link :to="{name: route.component}" v-else v-show="!route.has_permission ||  hasPermission(route.resource)">
                  <div class="menu-item clearfix" :class="{'active': $route.name.includes(route.component)}">
                     <div :class="route.icon || 'fa fa-columns'"></div>
                     <div class="menu-text">{{route.name || route.component}}</div>
                  </div>
               </router-link>
            </div>
         </div>
         
      </div>
   </div>
</template>

<script>
   export default {
      props:{
         routes: {
            type: [Array],
            default: () => {
               return [
                  { type: 'heading', name: 'MAIN'},
                  { 
                     icon: 'fa fa-paint-roller',component: 'Dashboard', name: 'Advanced UI', 
                     children: [
                        { icon: 'fa fa-columns',component: 'Widgets', name: 'Widgets'},
                     ]
                  },
               ]
            }
         },
      },
      data () {
         return {
            main_lang,
            resources: []
         }
      },
      methods: {
         toggleNav () {
            this.$el.querySelector('.navTrigger').classList.toggle('active')
            document.querySelector('.layout-sidenav').classList.toggle('icons-only')
         },
         toggleCollapse(id){
            this.$el.querySelector(`#menu-${id}`).classList.toggle('collapsed')
            this.$el.querySelector(`#${id}`).classList.toggle('show')
         },
         getChildren(children){
            return children.map(e => {return e.component})
         },
         async fetchResources(){
            let role = await $session.get('role')

            if(role[0].resources){
               this.resources = role[0].resources
            }
         },
         childrenHavePermissions(children){
            for (const resource of this.resources) {
               for (const child of children) {
                  if(resource.code && resource.code === child.resource && resource.permissions[1]){
                     return true
                  }
               }
            }

            return false
         },
         hasPermission(code){
            for (const resource of this.resources) {
               if(resource.code && resource.code === code && resource.permissions[1]){
                  return true
               }
            }

            return false
         }
      },
      async mounted(){
         await this.fetchResources()
      }
   }
</script>